<template>
    <header id="header">
        <router-link to='/' id="logo"></router-link>
        
        <ul id="menu" v-if="!is_mobile()">
            <li v-for="item in menu" class="active" :key="'menu' + item.link"><router-link :to="'/' + item.link">{{ item.name }}</router-link></li>
        </ul>

        <div id="header_left_side">
          <a class="support_btn" href="tel:0737799310">
           <div><img src="@/assets/headphones.png" alt=""> לתמיכה: 073-7799310</div>
          </a>
          <div id="user_area"><img src="@/assets/online_ico.png" alt=""> שלום {{user_data.display_name}}</div>
        </div>

    </header>
</template>

<script>

export default {

  props: ["user_data", "menu","profile"],
  
  data() {
    return {
      user_token: localStorage.getItem('user_token')
    };
  },
  
  computed: {

  },
  methods:{
    
    logout(){
      localStorage.removeItem('user_token');
      document.location = '/';

    },
    
  },


}
</script>